import { ExecutiveSummaryTransactionItemType } from "@/enums/enums";
import {
  ExecutiveSummaryAccountModel,
  ExecutiveSummaryDetailModel,
  ExecutiveSummaryPeriodModel,
  ExecutiveSummaryRemarkModel,
  ExecutiveSummarySettingInPageModel,
  ExecutiveSummarySettingModel,
  ExecutiveSummaryTransactionItemModel,
  ExecutiveSummaryTransactionModel,
  ExecutiveSummaryValueModel,
} from "@/model/executiveSummary/executiveSummaryModel";
function ConvertToCreateExecutiveSummaryPeriod(periodRaw: any): ExecutiveSummaryPeriodModel {
  let period: ExecutiveSummaryPeriodModel = new ExecutiveSummaryPeriodModel();
  period.fromChangeDate = periodRaw.fromChangeDate;
  period.toChangeDate = periodRaw.toChangeDate;
  period.fromDate = periodRaw.fromDate;
  period.toDate = periodRaw.toDate;
  return period;
}
function ConvertToCreateExecutiveSummaryPeriodList(periodRawList: any): Array<ExecutiveSummaryPeriodModel> {
  let periodList: Array<ExecutiveSummaryPeriodModel> = [];
  if (periodRawList && periodRawList.length > 0) {
    for (const periodRaw of periodRawList) {
      periodList.push(ConvertToCreateExecutiveSummaryPeriod(periodRaw));
    }
  }
  return periodList;
}
function ConvertToCreateExecutiveSummaryValue(valueRaw: any): ExecutiveSummaryValueModel {
  let value: ExecutiveSummaryValueModel = new ExecutiveSummaryValueModel();
  value.beforeValue = valueRaw.beforeValue;
  value.changePercent = valueRaw.changePercent;
  value.value = valueRaw.value;
  return value;
}
function ConvertToCreateExecutiveSummaryValueList(valueRawList: any): Array<ExecutiveSummaryValueModel> {
  let valueList: Array<ExecutiveSummaryValueModel> = [];
  if (valueRawList && valueRawList.length > 0) {
    for (const valueRaw of valueRawList) {
      valueList.push(ConvertToCreateExecutiveSummaryValue(valueRaw));
    }
  }
  return valueList;
}
function ConvertToCreateExecutiveSummaryAccount(accountRaw: any): ExecutiveSummaryAccountModel {
  let account: ExecutiveSummaryAccountModel = new ExecutiveSummaryAccountModel();
  account.accountId = accountRaw.accountId;
  account.valueList = ConvertToCreateExecutiveSummaryValueList(accountRaw.valueList);
  return account;
}
function ConvertToCreateExecutiveSummaryRemark(remarkRaw: any): ExecutiveSummaryRemarkModel {
  let remark: ExecutiveSummaryRemarkModel = new ExecutiveSummaryRemarkModel();
  if (remarkRaw) {
    remark.isHaveRemark = remarkRaw.no > 0;
    remark.no = remarkRaw.no;
    remark.description = remarkRaw.description;
    remark.header = remarkRaw.header;
  }
  return remark;
}
function ConvertToCreateExecutiveSummaryAccountList(accountRawList: any): Array<ExecutiveSummaryAccountModel> {
  let accountList: Array<ExecutiveSummaryAccountModel> = [];
  if (accountRawList && accountRawList.length > 0) {
    for (const accountRaw of accountRawList) {
      accountList.push(ConvertToCreateExecutiveSummaryAccount(accountRaw));
    }
  }
  return accountList;
}
function ConvertToCreateExecutiveSummaryTransactionItem(transactionItemRaw: any): ExecutiveSummaryTransactionItemModel {
  let transactionItem: ExecutiveSummaryTransactionItemModel = new ExecutiveSummaryTransactionItemModel();
  if (transactionItemRaw) {
    transactionItem.type = transactionItemRaw.type;
    transactionItem.remark = ConvertToCreateExecutiveSummaryRemark(transactionItemRaw.remark);
    transactionItem.accountList = ConvertToCreateExecutiveSummaryAccountList(transactionItemRaw.accountList);
    transactionItem.summaryList = ConvertToCreateExecutiveSummaryValueList(transactionItemRaw.summaryList);
  }
  return transactionItem;
}
function ConvertExecutiveSummaryTransactionBase(
  transactionRaw: any = null,
  fromDate: string,
  toDate: string
): ExecutiveSummaryTransactionModel {
  let transaction: ExecutiveSummaryTransactionModel = new ExecutiveSummaryTransactionModel();
  transaction.periodList = ConvertToCreateExecutiveSummaryPeriodList(transactionRaw.periodList);
  transaction.periodType = transactionRaw.periodType;
  transaction.fromDate = fromDate;
  transaction.toDate = toDate;
  transaction.operationIncome = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.operationIncome);
  transaction.costsOfSales = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.costsOfSales);
  transaction.grossProfit = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.grossProfit);
  transaction.expenses = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.expenses);
  transaction.costOfFinancing = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.costOfFinancing);
  transaction.taxRevenues = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.taxRevenues);
  transaction.netProfit = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.netProfit);
  transaction.cashReceived = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.cashReceived);
  transaction.cashSpent = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.cashSpent);
  transaction.gainsInForeignExchange = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.gainsInForeignExchange
  );
  transaction.netCashReceived = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.netCashReceived);
  transaction.cashBalance = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.cashBalance);
  transaction.accountsReceivable = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.accountsReceivable);
  transaction.inventory = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.inventory);
  transaction.accountsPayable = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.accountsPayable);
  transaction.quickRatio = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.quickRatio);
  transaction.inventoryTurnOver = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.inventoryTurnOver);
  transaction.receivablesTurnOver = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.receivablesTurnOver);
  transaction.accountPayableTurnOverRatio = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.accountPayableTurnOverRatio
  );
  transaction.averagePaymentPeriod = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.averagePaymentPeriod
  );
  transaction.averageInventoryPeriod = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.averageInventoryPeriod
  );
  transaction.averageCollectionPeriod = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.averageCollectionPeriod
  );
  transaction.cashConversionCycle = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.cashConversionCycle);

  transaction.quotationNumberIssued = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.quotationNumberIssued
  );
  transaction.quotationNetAmountIssued = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.quotationNetAmountIssued
  );
  transaction.quotationAverageIssued = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.quotationAverageIssued
  );
  transaction.invoiceNumberIssued = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.invoiceNumberIssued);
  transaction.invoiceNetAmountIssued = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.invoiceNetAmountIssued
  );
  transaction.invoiceAverageIssued = ConvertToCreateExecutiveSummaryTransactionItem(
    transactionRaw.invoiceAverageIssued
  );
  transaction.roe = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.roe);
  transaction.netProfitMargin = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.netProfitMargin);
  transaction.totalAssetTurnOver = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.totalAssetTurnOver);
  transaction.equityMultiplier = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.equityMultiplier);
  transaction.roa = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.roa);
  transaction.totalEquityTurnOver = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.totalEquityTurnOver);
  transaction.grossProfitRatio = ConvertToCreateExecutiveSummaryTransactionItem(transactionRaw.grossProfitRatio);
  return transaction;
}

export function RemoveRemarkExecutiveSummary(remark: ExecutiveSummaryRemarkModel) {
  remark.isHaveRemark = false;
  remark.description = "";
  remark.header = "";
}

export function RemoveRemarkExecutiveSummaryBySetting(
  transaction: ExecutiveSummaryTransactionModel,
  setting: ExecutiveSummarySettingModel
) {
  if (setting.operationIncomeHidden) {
    RemoveRemarkExecutiveSummary(transaction.operationIncome.remark);
  }
  if (setting.costsOfSalesHidden) {
    RemoveRemarkExecutiveSummary(transaction.costsOfSales.remark);
  }
  if (setting.grossProfitHidden) {
    RemoveRemarkExecutiveSummary(transaction.grossProfit.remark);
  }
  if (setting.expensesHidden) {
    RemoveRemarkExecutiveSummary(transaction.expenses.remark);
  }
  if (setting.costOfFinancingHidden) {
    RemoveRemarkExecutiveSummary(transaction.costOfFinancing.remark);
  }
  if (setting.taxRevenuesHidden) {
    RemoveRemarkExecutiveSummary(transaction.taxRevenues.remark);
  }
  if (setting.netProfitHidden) {
    RemoveRemarkExecutiveSummary(transaction.netProfit.remark);
  }
  if (setting.cashReceivedHidden) {
    RemoveRemarkExecutiveSummary(transaction.cashReceived.remark);
  }
  if (setting.cashSpentHidden) {
    RemoveRemarkExecutiveSummary(transaction.cashSpent.remark);
  }
  if (setting.gainsInForeignExchangeHidden) {
    RemoveRemarkExecutiveSummary(transaction.gainsInForeignExchange.remark);
  }
  if (setting.netCashReceivedHidden) {
    RemoveRemarkExecutiveSummary(transaction.netCashReceived.remark);
  }
  if (setting.cashBalanceHidden) {
    RemoveRemarkExecutiveSummary(transaction.cashBalance.remark);
  }
  if (setting.accountsReceivableHidden) {
    RemoveRemarkExecutiveSummary(transaction.accountsReceivable.remark);
  }
  if (setting.inventoryHidden) {
    RemoveRemarkExecutiveSummary(transaction.inventory.remark);
  }
  if (setting.accountsPayableHidden) {
    RemoveRemarkExecutiveSummary(transaction.accountsPayable.remark);
  }
  if (setting.quickRatioHidden) {
    RemoveRemarkExecutiveSummary(transaction.quickRatio.remark);
  }
  if (setting.inventoryTurnOverHidden) {
    RemoveRemarkExecutiveSummary(transaction.inventoryTurnOver.remark);
  }
  if (setting.receivablesTurnOverHidden) {
    RemoveRemarkExecutiveSummary(transaction.receivablesTurnOver.remark);
  }
  if (setting.accountPayableTurnOverRatioHidden) {
    RemoveRemarkExecutiveSummary(transaction.accountPayableTurnOverRatio.remark);
  }
  if (setting.averagePaymentPeriodHidden) {
    RemoveRemarkExecutiveSummary(transaction.averagePaymentPeriod.remark);
  }
  if (setting.averageInventoryPeriodHidden) {
    RemoveRemarkExecutiveSummary(transaction.averageInventoryPeriod.remark);
  }
  if (setting.averageCollectionPeriodHidden) {
    RemoveRemarkExecutiveSummary(transaction.averageCollectionPeriod.remark);
  }
  if (setting.cashConversionCycleHidden) {
    RemoveRemarkExecutiveSummary(transaction.cashConversionCycle.remark);
  }
  if (setting.quotationNumberIssuedHidden) {
    RemoveRemarkExecutiveSummary(transaction.quotationNumberIssued.remark);
  }
  if (setting.quotationNetAmountIssuedHidden) {
    RemoveRemarkExecutiveSummary(transaction.quotationNetAmountIssued.remark);
  }
  if (setting.quotationAverageIssuedHidden) {
    RemoveRemarkExecutiveSummary(transaction.quotationAverageIssued.remark);
  }
  if (setting.invoiceNumberIssuedHidden) {
    RemoveRemarkExecutiveSummary(transaction.invoiceNumberIssued.remark);
  }
  if (setting.invoiceNetAmountIssuedHidden) {
    RemoveRemarkExecutiveSummary(transaction.invoiceNetAmountIssued.remark);
  }
  if (setting.invoiceAverageIssuedHidden) {
    RemoveRemarkExecutiveSummary(transaction.invoiceAverageIssued.remark);
  }
  if (setting.roeHidden) {
    RemoveRemarkExecutiveSummary(transaction.roe.remark);
  }
  if (setting.netProfitMarginHidden) {
    RemoveRemarkExecutiveSummary(transaction.netProfitMargin.remark);
  }
  if (setting.totalAssetTurnOverHidden) {
    RemoveRemarkExecutiveSummary(transaction.totalAssetTurnOver.remark);
  }
  if (setting.equityMultiplierHidden) {
    RemoveRemarkExecutiveSummary(transaction.equityMultiplier.remark);
  }
  if (setting.roaHidden) {
    RemoveRemarkExecutiveSummary(transaction.roa.remark);
  }
  if (setting.totalEquityTurnOverHidden) {
    RemoveRemarkExecutiveSummary(transaction.totalEquityTurnOver.remark);
  }
  if (setting.grossProfitRatioHidden) {
    RemoveRemarkExecutiveSummary(transaction.grossProfitRatio.remark);
  }
}

export function SetRunningNumberExecutiveSummaryRemark(
  transaction: ExecutiveSummaryTransactionModel,
  setting: ExecutiveSummarySettingModel
) {
  let no = 0;
  transaction.operationIncome.remark.no =
    transaction.operationIncome.remark.isHaveRemark && !setting.operationIncomeHidden ? ++no : 0;
  transaction.costsOfSales.remark.no =
    transaction.costsOfSales.remark.isHaveRemark && !setting.costsOfSalesHidden ? ++no : 0;
  transaction.grossProfit.remark.no =
    transaction.grossProfit.remark.isHaveRemark && !setting.grossProfitHidden ? ++no : 0;
  transaction.expenses.remark.no = transaction.expenses.remark.isHaveRemark && !setting.expensesHidden ? ++no : 0;
  transaction.costOfFinancing.remark.no =
    transaction.costOfFinancing.remark.isHaveRemark && !setting.costOfFinancingHidden ? ++no : 0;
  transaction.taxRevenues.remark.no =
    transaction.taxRevenues.remark.isHaveRemark && !setting.taxRevenuesHidden ? ++no : 0;
  transaction.netProfit.remark.no = transaction.netProfit.remark.isHaveRemark && !setting.netProfitHidden ? ++no : 0;
  transaction.cashReceived.remark.no =
    transaction.cashReceived.remark.isHaveRemark && !setting.cashReceivedHidden ? ++no : 0;
  transaction.cashSpent.remark.no = transaction.cashSpent.remark.isHaveRemark && !setting.cashSpentHidden ? ++no : 0;
  transaction.gainsInForeignExchange.remark.no =
    transaction.gainsInForeignExchange.remark.isHaveRemark && !setting.gainsInForeignExchangeHidden ? ++no : 0;
  transaction.netCashReceived.remark.no =
    transaction.netCashReceived.remark.isHaveRemark && !setting.netCashReceivedHidden ? ++no : 0;
  transaction.cashBalance.remark.no =
    transaction.cashBalance.remark.isHaveRemark && !setting.cashBalanceHidden ? ++no : 0;
  transaction.accountsReceivable.remark.no =
    transaction.accountsReceivable.remark.isHaveRemark && !setting.accountsReceivableHidden ? ++no : 0;
  transaction.inventory.remark.no = transaction.inventory.remark.isHaveRemark && !setting.inventoryHidden ? ++no : 0;
  transaction.accountsPayable.remark.no =
    transaction.accountsPayable.remark.isHaveRemark && !setting.accountsPayableHidden ? ++no : 0;
  transaction.quickRatio.remark.no = transaction.quickRatio.remark.isHaveRemark && !setting.quickRatioHidden ? ++no : 0;
  transaction.inventoryTurnOver.remark.no =
    transaction.inventoryTurnOver.remark.isHaveRemark && !setting.inventoryTurnOverHidden ? ++no : 0;
  transaction.receivablesTurnOver.remark.no =
    transaction.receivablesTurnOver.remark.isHaveRemark && !setting.receivablesTurnOverHidden ? ++no : 0;
  transaction.accountPayableTurnOverRatio.remark.no =
    transaction.accountPayableTurnOverRatio.remark.isHaveRemark && !setting.accountPayableTurnOverRatioHidden
      ? ++no
      : 0;
  transaction.averagePaymentPeriod.remark.no =
    transaction.averagePaymentPeriod.remark.isHaveRemark && !setting.averagePaymentPeriodHidden ? ++no : 0;
  transaction.averageInventoryPeriod.remark.no =
    transaction.averageInventoryPeriod.remark.isHaveRemark && !setting.averageInventoryPeriodHidden ? ++no : 0;
  transaction.averageCollectionPeriod.remark.no =
    transaction.averageCollectionPeriod.remark.isHaveRemark && !setting.averageCollectionPeriodHidden ? ++no : 0;
  transaction.cashConversionCycle.remark.no =
    transaction.cashConversionCycle.remark.isHaveRemark && !setting.cashConversionCycleHidden ? ++no : 0;
  transaction.quotationNumberIssued.remark.no =
    transaction.quotationNumberIssued.remark.isHaveRemark && !setting.quotationNumberIssuedHidden ? ++no : 0;
  transaction.quotationNetAmountIssued.remark.no =
    transaction.quotationNetAmountIssued.remark.isHaveRemark && !setting.quotationNetAmountIssuedHidden ? ++no : 0;
  transaction.quotationAverageIssued.remark.no =
    transaction.quotationAverageIssued.remark.isHaveRemark && !setting.quotationAverageIssuedHidden ? ++no : 0;
  transaction.invoiceNumberIssued.remark.no =
    transaction.invoiceNumberIssued.remark.isHaveRemark && !setting.invoiceNumberIssuedHidden ? ++no : 0;
  transaction.invoiceNetAmountIssued.remark.no =
    transaction.invoiceNetAmountIssued.remark.isHaveRemark && !setting.invoiceNetAmountIssuedHidden ? ++no : 0;
  transaction.invoiceAverageIssued.remark.no =
    transaction.invoiceAverageIssued.remark.isHaveRemark && !setting.invoiceAverageIssuedHidden ? ++no : 0;
  transaction.roe.remark.no = transaction.roe.remark.isHaveRemark && !setting.roeHidden ? ++no : 0;
  transaction.netProfitMargin.remark.no =
    transaction.netProfitMargin.remark.isHaveRemark && !setting.netProfitMarginHidden ? ++no : 0;
  transaction.totalAssetTurnOver.remark.no =
    transaction.totalAssetTurnOver.remark.isHaveRemark && !setting.totalAssetTurnOverHidden ? ++no : 0;
  transaction.equityMultiplier.remark.no =
    transaction.equityMultiplier.remark.isHaveRemark && !setting.equityMultiplierHidden ? ++no : 0;
  transaction.roa.remark.no = transaction.roa.remark.isHaveRemark && !setting.roaHidden ? ++no : 0;
  transaction.totalEquityTurnOver.remark.no =
    transaction.totalEquityTurnOver.remark.isHaveRemark && !setting.totalEquityTurnOverHidden ? ++no : 0;
  transaction.grossProfitRatio.remark.no =
    transaction.grossProfitRatio.remark.isHaveRemark && !setting.grossProfitRatioHidden ? ++no : 0;
}
export function GetExecutiveSummaryRemarkList(
  transaction: ExecutiveSummaryTransactionModel
): Array<ExecutiveSummaryRemarkModel> {
  let remarkList: Array<ExecutiveSummaryRemarkModel> = [];
  if (transaction.operationIncome.remark.isHaveRemark) {
    remarkList.push(transaction.operationIncome.remark);
  }
  if (transaction.costsOfSales.remark.isHaveRemark) {
    remarkList.push(transaction.costsOfSales.remark);
  }
  if (transaction.grossProfit.remark.isHaveRemark) {
    remarkList.push(transaction.grossProfit.remark);
  }
  if (transaction.expenses.remark.isHaveRemark) {
    remarkList.push(transaction.expenses.remark);
  }
  if (transaction.costOfFinancing.remark.isHaveRemark) {
    remarkList.push(transaction.costOfFinancing.remark);
  }
  if (transaction.taxRevenues.remark.isHaveRemark) {
    remarkList.push(transaction.taxRevenues.remark);
  }
  if (transaction.netProfit.remark.isHaveRemark) {
    remarkList.push(transaction.netProfit.remark);
  }
  if (transaction.cashReceived.remark.isHaveRemark) {
    remarkList.push(transaction.cashReceived.remark);
  }
  if (transaction.cashSpent.remark.isHaveRemark) {
    remarkList.push(transaction.cashSpent.remark);
  }
  if (transaction.gainsInForeignExchange.remark.isHaveRemark) {
    remarkList.push(transaction.gainsInForeignExchange.remark);
  }
  if (transaction.netCashReceived.remark.isHaveRemark) {
    remarkList.push(transaction.netCashReceived.remark);
  }
  if (transaction.cashBalance.remark.isHaveRemark) {
    remarkList.push(transaction.cashBalance.remark);
  }
  if (transaction.accountsReceivable.remark.isHaveRemark) {
    remarkList.push(transaction.accountsReceivable.remark);
  }
  if (transaction.inventory.remark.isHaveRemark) {
    remarkList.push(transaction.inventory.remark);
  }
  if (transaction.accountsPayable.remark.isHaveRemark) {
    remarkList.push(transaction.accountsPayable.remark);
  }
  if (transaction.quickRatio.remark.isHaveRemark) {
    remarkList.push(transaction.quickRatio.remark);
  }
  if (transaction.inventoryTurnOver.remark.isHaveRemark) {
    remarkList.push(transaction.inventoryTurnOver.remark);
  }
  if (transaction.receivablesTurnOver.remark.isHaveRemark) {
    remarkList.push(transaction.receivablesTurnOver.remark);
  }
  if (transaction.accountPayableTurnOverRatio.remark.isHaveRemark) {
    remarkList.push(transaction.accountPayableTurnOverRatio.remark);
  }
  if (transaction.averagePaymentPeriod.remark.isHaveRemark) {
    remarkList.push(transaction.averagePaymentPeriod.remark);
  }
  if (transaction.averageInventoryPeriod.remark.isHaveRemark) {
    remarkList.push(transaction.averageInventoryPeriod.remark);
  }
  if (transaction.averageCollectionPeriod.remark.isHaveRemark) {
    remarkList.push(transaction.averageCollectionPeriod.remark);
  }
  if (transaction.cashConversionCycle.remark.isHaveRemark) {
    remarkList.push(transaction.cashConversionCycle.remark);
  }
  if (transaction.quotationNumberIssued.remark.isHaveRemark) {
    remarkList.push(transaction.quotationNumberIssued.remark);
  }
  if (transaction.quotationNetAmountIssued.remark.isHaveRemark) {
    remarkList.push(transaction.quotationNetAmountIssued.remark);
  }
  if (transaction.quotationAverageIssued.remark.isHaveRemark) {
    remarkList.push(transaction.quotationAverageIssued.remark);
  }
  if (transaction.invoiceNumberIssued.remark.isHaveRemark) {
    remarkList.push(transaction.invoiceNumberIssued.remark);
  }
  if (transaction.invoiceNetAmountIssued.remark.isHaveRemark) {
    remarkList.push(transaction.invoiceNetAmountIssued.remark);
  }
  if (transaction.invoiceAverageIssued.remark.isHaveRemark) {
    remarkList.push(transaction.invoiceAverageIssued.remark);
  }
  if (transaction.roe.remark.isHaveRemark) {
    remarkList.push(transaction.roe.remark);
  }
  if (transaction.netProfitMargin.remark.isHaveRemark) {
    remarkList.push(transaction.netProfitMargin.remark);
  }
  if (transaction.totalAssetTurnOver.remark.isHaveRemark) {
    remarkList.push(transaction.totalAssetTurnOver.remark);
  }
  if (transaction.equityMultiplier.remark.isHaveRemark) {
    remarkList.push(transaction.equityMultiplier.remark);
  }
  if (transaction.roa.remark.isHaveRemark) {
    remarkList.push(transaction.roa.remark);
  }
  if (transaction.totalEquityTurnOver.remark.isHaveRemark) {
    remarkList.push(transaction.totalEquityTurnOver.remark);
  }
  if (transaction.grossProfitRatio.remark.isHaveRemark) {
    remarkList.push(transaction.grossProfitRatio.remark);
  }
  return remarkList;
}
export function ConvertExecutiveSummarySettingModel(settingRaw: any): ExecutiveSummarySettingModel {
  let setting: ExecutiveSummarySettingModel = new ExecutiveSummarySettingModel();
  setting.operationIncomeHidden = settingRaw.operationIncomeHidden;
  setting.costsOfSalesHidden = settingRaw.costsOfSalesHidden;
  setting.grossProfitHidden = settingRaw.grossProfitHidden;
  setting.expensesHidden = settingRaw.expensesHidden;
  setting.costOfFinancingHidden = settingRaw.costOfFinancingHidden;
  setting.taxRevenuesHidden = settingRaw.taxRevenuesHidden;
  setting.netProfitHidden = settingRaw.netProfitHidden;
  setting.cashReceivedHidden = settingRaw.cashReceivedHidden;
  setting.cashSpentHidden = settingRaw.cashSpentHidden;
  setting.gainsInForeignExchangeHidden = settingRaw.gainsInForeignExchangeHidden;
  setting.netCashReceivedHidden = settingRaw.netCashReceivedHidden;
  setting.cashBalanceHidden = settingRaw.cashBalanceHidden;
  setting.accountsReceivableHidden = settingRaw.accountsReceivableHidden;
  setting.inventoryHidden = settingRaw.inventoryHidden;
  setting.accountsPayableHidden = settingRaw.accountsPayableHidden;
  setting.quickRatioHidden = settingRaw.quickRatioHidden;
  setting.inventoryTurnOverHidden = settingRaw.inventoryTurnOverHidden;
  setting.receivablesTurnOverHidden = settingRaw.receivablesTurnOverHidden;
  setting.accountPayableTurnOverRatioHidden = settingRaw.accountPayableTurnOverRatioHidden;
  setting.averagePaymentPeriodHidden = settingRaw.averagePaymentPeriodHidden;
  setting.averageInventoryPeriodHidden = settingRaw.averageInventoryPeriodHidden;
  setting.averageCollectionPeriodHidden = settingRaw.averageCollectionPeriodHidden;
  setting.cashConversionCycleHidden = settingRaw.cashConversionCycleHidden;
  setting.quotationNumberIssuedHidden = settingRaw.quotationNumberIssuedHidden;
  setting.quotationNetAmountIssuedHidden = settingRaw.quotationNetAmountIssuedHidden;
  setting.quotationAverageIssuedHidden = settingRaw.quotationAverageIssuedHidden;
  setting.invoiceNumberIssuedHidden = settingRaw.invoiceNumberIssuedHidden;
  setting.invoiceNetAmountIssuedHidden = settingRaw.invoiceNetAmountIssuedHidden;
  setting.invoiceAverageIssuedHidden = settingRaw.invoiceAverageIssuedHidden;
  setting.roeHidden = settingRaw.roeHidden;
  setting.netProfitMarginHidden = settingRaw.netProfitMarginHidden;
  setting.totalAssetTurnOverHidden = settingRaw.totalAssetTurnOverHidden;
  setting.equityMultiplierHidden = settingRaw.equityMultiplierHidden;
  setting.roaHidden = settingRaw.roaHidden;
  setting.totalEquityTurnOverHidden = settingRaw.totalEquityTurnOverHidden;
  setting.grossProfitRatioHidden = settingRaw.grossProfitRatioHidden;
  return setting;
}
export function ConvertExecutiveSummarySettingInPage(
  settingRaw: ExecutiveSummarySettingModel
): ExecutiveSummarySettingInPageModel {
  let setting: ExecutiveSummarySettingInPageModel = new ExecutiveSummarySettingInPageModel();
  setting.operationIncomeShow = !settingRaw.operationIncomeHidden;
  setting.costsOfSalesShow = !settingRaw.costsOfSalesHidden;
  setting.grossProfitShow = !settingRaw.grossProfitHidden;
  setting.expensesShow = !settingRaw.expensesHidden;
  setting.costOfFinancingShow = !settingRaw.costOfFinancingHidden;
  setting.taxRevenuesShow = !settingRaw.taxRevenuesHidden;
  setting.netProfitShow = !settingRaw.netProfitHidden;
  setting.cashReceivedShow = !settingRaw.cashReceivedHidden;
  setting.cashSpentShow = !settingRaw.cashSpentHidden;
  setting.gainsInForeignExchangeShow = !settingRaw.gainsInForeignExchangeHidden;
  setting.netCashReceivedShow = !settingRaw.netCashReceivedHidden;
  setting.cashBalanceShow = !settingRaw.cashBalanceHidden;
  setting.accountsReceivableShow = !settingRaw.accountsReceivableHidden;
  setting.inventoryShow = !settingRaw.inventoryHidden;
  setting.accountsPayableShow = !settingRaw.accountsPayableHidden;
  setting.quickRatioShow = !settingRaw.quickRatioHidden;
  setting.inventoryTurnOverShow = !settingRaw.inventoryTurnOverHidden;
  setting.receivablesTurnOverShow = !settingRaw.receivablesTurnOverHidden;
  setting.accountPayableTurnOverRatioShow = !settingRaw.accountPayableTurnOverRatioHidden;
  setting.averagePaymentPeriodShow = !settingRaw.averagePaymentPeriodHidden;
  setting.averageInventoryPeriodShow = !settingRaw.averageInventoryPeriodHidden;
  setting.averageCollectionPeriodShow = !settingRaw.averageCollectionPeriodHidden;
  setting.cashConversionCycleShow = !settingRaw.cashConversionCycleHidden;
  setting.quotationNumberIssuedShow = !settingRaw.quotationNumberIssuedHidden;
  setting.quotationNetAmountIssuedShow = !settingRaw.quotationNetAmountIssuedHidden;
  setting.quotationAverageIssuedShow = !settingRaw.quotationAverageIssuedHidden;
  setting.invoiceNumberIssuedShow = !settingRaw.invoiceNumberIssuedHidden;
  setting.invoiceNetAmountIssuedShow = !settingRaw.invoiceNetAmountIssuedHidden;
  setting.invoiceAverageIssuedShow = !settingRaw.invoiceAverageIssuedHidden;
  setting.roeShow = !settingRaw.roeHidden;
  setting.netProfitMarginShow = !settingRaw.netProfitMarginHidden;
  setting.totalAssetTurnOverShow = !settingRaw.totalAssetTurnOverHidden;
  setting.equityMultiplierShow = !settingRaw.equityMultiplierHidden;
  setting.roaShow = !settingRaw.roaHidden;
  setting.totalEquityTurnOverShow = !settingRaw.totalEquityTurnOverHidden;
  setting.grossProfitRatioShow = !settingRaw.grossProfitRatioHidden;
  return setting;
}
export function ConvertExecutiveSummarySetting(
  settingRaw: ExecutiveSummarySettingInPageModel
): ExecutiveSummarySettingModel {
  let setting: ExecutiveSummarySettingModel = new ExecutiveSummarySettingModel();
  setting.operationIncomeHidden = !settingRaw.operationIncomeShow;
  setting.costsOfSalesHidden = !settingRaw.costsOfSalesShow;
  setting.grossProfitHidden = !settingRaw.grossProfitShow;
  setting.expensesHidden = !settingRaw.expensesShow;
  setting.costOfFinancingHidden = !settingRaw.costOfFinancingShow;
  setting.taxRevenuesHidden = !settingRaw.taxRevenuesShow;
  setting.netProfitHidden = !settingRaw.netProfitShow;
  setting.cashReceivedHidden = !settingRaw.cashReceivedShow;
  setting.cashSpentHidden = !settingRaw.cashSpentShow;
  setting.gainsInForeignExchangeHidden = !settingRaw.gainsInForeignExchangeShow;
  setting.netCashReceivedHidden = !settingRaw.netCashReceivedShow;
  setting.cashBalanceHidden = !settingRaw.cashBalanceShow;
  setting.accountsReceivableHidden = !settingRaw.accountsReceivableShow;
  setting.inventoryHidden = !settingRaw.inventoryShow;
  setting.accountsPayableHidden = !settingRaw.accountsPayableShow;
  setting.quickRatioHidden = !settingRaw.quickRatioShow;
  setting.inventoryTurnOverHidden = !settingRaw.inventoryTurnOverShow;
  setting.receivablesTurnOverHidden = !settingRaw.receivablesTurnOverShow;
  setting.accountPayableTurnOverRatioHidden = !settingRaw.accountPayableTurnOverRatioShow;
  setting.averagePaymentPeriodHidden = !settingRaw.averagePaymentPeriodShow;
  setting.averageInventoryPeriodHidden = !settingRaw.averageInventoryPeriodShow;
  setting.averageCollectionPeriodHidden = !settingRaw.averageCollectionPeriodShow;
  setting.cashConversionCycleHidden = !settingRaw.cashConversionCycleShow;
  setting.quotationNumberIssuedHidden = !settingRaw.quotationNumberIssuedShow;
  setting.quotationNetAmountIssuedHidden = !settingRaw.quotationNetAmountIssuedShow;
  setting.quotationAverageIssuedHidden = !settingRaw.quotationAverageIssuedShow;
  setting.invoiceNumberIssuedHidden = !settingRaw.invoiceNumberIssuedShow;
  setting.invoiceNetAmountIssuedHidden = !settingRaw.invoiceNetAmountIssuedShow;
  setting.invoiceAverageIssuedHidden = !settingRaw.invoiceAverageIssuedShow;
  setting.roeHidden = !settingRaw.roeShow;
  setting.netProfitMarginHidden = !settingRaw.netProfitMarginShow;
  setting.totalAssetTurnOverHidden = !settingRaw.totalAssetTurnOverShow;
  setting.equityMultiplierHidden = !settingRaw.equityMultiplierShow;
  setting.roaHidden = !settingRaw.roaShow;
  setting.totalEquityTurnOverHidden = !settingRaw.totalEquityTurnOverShow;
  setting.grossProfitRatioHidden = !settingRaw.grossProfitRatioShow;
  return setting;
}
export function ConvertToCreateExecutiveSummaryTransaction(
  transactionRaw: any = null,
  fromDate: string,
  toDate: string
): ExecutiveSummaryTransactionModel {
  return ConvertExecutiveSummaryTransactionBase(transactionRaw, fromDate, toDate);
}
export function ConvertToExecutiveSummaryTransactionDetail(detailRaw: any): ExecutiveSummaryDetailModel {
  let detail: ExecutiveSummaryDetailModel = new ExecutiveSummaryDetailModel();
  detail.id = detailRaw.id;
  detail.uuId = detailRaw.uuId;
  detail.status = detailRaw.status;
  detail.isDeleted = detailRaw.isDeleted;
  detail.number = detailRaw.number;
  detail.name = detailRaw.name;
  detail.fromDate = detailRaw.fromDate;
  detail.toDate = detailRaw.toDate;
  detail.createdUserId = detailRaw.createdUserId;
  detail.createdDateTime = detailRaw.createdDateTime;
  detail.approvedUserId = detailRaw.approvedUserId;
  detail.approvedDateTime = detailRaw.approvedDateTime;
  detail.updatedUserId = detailRaw.updatedUserId;
  detail.updatedDateTime = detailRaw.updatedDateTime;
  detail.setting = ConvertExecutiveSummarySettingModel(detailRaw.setting);
  detail.transaction = ConvertExecutiveSummaryTransactionBase(
    detailRaw.transaction,
    detail.fromDate.ToDateJsonString(),
    detail.toDate.ToDateJsonString()
  );
  return detail;
}
export function SetAccountToCreateExecutiveSummaryTransaction(
  transactionItem: ExecutiveSummaryTransactionItemModel,
  accountMap: Map<number, any>
) {
  if (transactionItem.accountList && transactionItem.accountList.length > 0) {
    for (let account of transactionItem.accountList) {
      let selectedAccount = accountMap.get(account.accountId);
      if (selectedAccount) {
        account.accountName = selectedAccount.name.locale;
        account.accountCode = selectedAccount.code;
        account.accountNameEn = selectedAccount.english;
        account.accountNameTh = selectedAccount.thai;
      } else {
        account.accountName = "";
        account.accountCode = "";
        account.accountNameEn = "";
        account.accountNameTh = "";
      }
    }
  }
}
export function ConvertToTransactionItemType(TransactionItemType: number) {
  let transactionItemTypeName = "";
  switch (TransactionItemType) {
    case ExecutiveSummaryTransactionItemType.OperationIncome:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Operating_Income";
      break;
    case ExecutiveSummaryTransactionItemType.CostsOfSales:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Costs_of_Sales";
      break;
    case ExecutiveSummaryTransactionItemType.GrossProfit:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Gross_Profit";
      break;
    case ExecutiveSummaryTransactionItemType.Expenses:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Expenses";
      break;
    case ExecutiveSummaryTransactionItemType.CostOfFinancing:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Cost_of_Financing";
      break;
    case ExecutiveSummaryTransactionItemType.TaxRevenues:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Tax_Revenues";
      break;
    case ExecutiveSummaryTransactionItemType.NetProfit:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Net_Profit";
      break;
    case ExecutiveSummaryTransactionItemType.CashReceived:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Cash_Received";
      break;
    case ExecutiveSummaryTransactionItemType.CashSpent:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Cash_Spent";
      break;
    case ExecutiveSummaryTransactionItemType.GainsInForeignExchange:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Gains_In_Foreign_Exchange";
      break;
    case ExecutiveSummaryTransactionItemType.NetCashReceived:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Net_Cash_Received";
      break;
    case ExecutiveSummaryTransactionItemType.CashBalance:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Cash_Balance";
      break;
    case ExecutiveSummaryTransactionItemType.AccountsReceivable:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Accounts_Receivable";
      break;
    case ExecutiveSummaryTransactionItemType.Inventory:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Inventory";
      break;
    case ExecutiveSummaryTransactionItemType.AccountsPayable:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Accounts_Payable";
      break;
    case ExecutiveSummaryTransactionItemType.QuickRatio:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Quick_Ratio";
      break;
    case ExecutiveSummaryTransactionItemType.InventoryTurnOver:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Inventory_Turnover";
      break;
    case ExecutiveSummaryTransactionItemType.ReceivablesTurnOver:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Receivables_Turnover";
      break;
    case ExecutiveSummaryTransactionItemType.AccountPayableTurnOverRatio:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Account_Payable_Turnover_Ratio";
      break;
    case ExecutiveSummaryTransactionItemType.AveragePaymentPeriod:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Average_Payment_Period";
      break;
    case ExecutiveSummaryTransactionItemType.AverageInventoryPeriod:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Average_Inventory_Period";
      break;
    case ExecutiveSummaryTransactionItemType.AverageCollectionPeriod:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Average_Collection_Period";
      break;
    case ExecutiveSummaryTransactionItemType.CashConversionCycle:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Cash_Conversion_Cycle";
      break;
    case ExecutiveSummaryTransactionItemType.QuotationNumberIssued:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Number_Quotation_Issued";
      break;
    case ExecutiveSummaryTransactionItemType.QuotationNetAmountIssued:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Total_Value_Quotation_Issued";
      break;
    case ExecutiveSummaryTransactionItemType.QuotationAverageIssued:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Average_Value_Quotation";
      break;
    case ExecutiveSummaryTransactionItemType.InvoiceNumberIssued:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Number_Invoice_Issued";
      break;
    case ExecutiveSummaryTransactionItemType.InvoiceNetAmountIssued:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Total_Value_Invoice_Issued";
      break;
    case ExecutiveSummaryTransactionItemType.InvoiceAverageIssued:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Average_Value_Invoice";
      break;
    case ExecutiveSummaryTransactionItemType.ROE:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.ROE";
      break;
    case ExecutiveSummaryTransactionItemType.NetProfitMargin:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Net_Profit_Margin";
      break;
    case ExecutiveSummaryTransactionItemType.TotalAssetTurnOver:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Total_Asset_Turnover";
      break;
    case ExecutiveSummaryTransactionItemType.EquityMultiplier:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Equity_Multiplier";
      break;
    case ExecutiveSummaryTransactionItemType.ROA:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.ROA";
      break;
    case ExecutiveSummaryTransactionItemType.TotalEquityTurnOver:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Total_Equity_Turnover";
      break;
    case ExecutiveSummaryTransactionItemType.GrossProfitRatio:
      transactionItemTypeName = "ExecutiveSummaryTransactionItemType.Gross_Profit_Ratio";
      break;
  }
  return transactionItemTypeName;
}
